app.controller('stateOfHealthTakenDrugListController', ['$scope', '$state', '$mdDialog', '$translate', 'edm.applicationModel',
    'applicationModel', 'patientModel', 'userModel', 'prescribedDrugModel',
    function ($scope, $state, $mdDialog, $translate, edmApplicationModel, applicationModel, patientModel, userModel,
              prescribedDrugModel) {

        var listeners = {};

        function setData() {
            $scope.takenDrugs = null;
            $scope.numberOfPages = null;

            $scope.criteria = new TakenDrugDataGridCriteria();
            $scope.criteria.idPatient = $state.params.patientId;
            $scope.currentUserId = userModel.currentUser.id;

            $scope.columns = [
                {
                    displayName: 'T.DATA.DATE',
                    cellTemplate: 'edm/application/view/app/patient/grid-template/data-row-dates.html'
                },
                {
                    displayName: 'T.MODULE.PATIENT.DRUG_NAME',
                    field: '(recipe) ? "Lek recepturowy" : drug.name + "(" + drug.commonName + ", " + drug.strength + ", " + drug.form + ", " + drug.packing + ")"'
                    //cellTemplate: 'edm/application/view/app/patient/grid-template/data-taken-drug-additional-information.html' // fixme
                },
                /*{
                    field: 'notes',
                    displayName: 'T.MODULE.PATIENT.NOTES'
                },*/
                {
                    field: 'chronic | yesNo',
                    displayName: 'T.MODULE.PATIENT.TAKEN_CHRONIC'
                },
                {
                    cellTemplate: 'edm/application/view/app/patient/grid-template/data-taken-drug-row-actions.html'
                }
            ];

            $scope.buttons = [
                {
                    icon: 'content:add',
                    action: 'addTakenDrug'
                },
                {
                    label: $translate.instant('T.MODULE.PERSONAL_DATA.SHOW_ALL'),
                    action: 'getDataPage'
                }
            ];

            $scope.showOptions = {
                all: false
            }
        }


        function setPermissions() {
        }

        function setListeners() {
            listeners.onTakenDrugDataPageLoad = function(dataPage) {
                $scope.takenDrugs = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            }
        }

        function setActions() {
            $scope.criteriaChanged = function () {
                $scope.getTakenDrugDataPage().then(listeners.onTakenDrugDataPageLoad);
            };

            $scope.addTakenDrug = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-takenDrug.html',
                    controller: 'popupTakenDrugCreateController'
                })
                    .then(function (data) {
                        $scope.getTakenDrugDataPage();
                    }, function () {
                        //cancel
                    });
            };

            $scope.previewTakenDrug = function(takenDrug) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-takenDrug.html',
                    controller: 'popupTakenDrugUpdateController',
                    resolve: {
                        takenDrugToUpdate: function() {
                            return takenDrug;
                        },
                        preview: function() {
                            return true;
                        }
                    }
                }).then(function (data) {
                    patientModel.getStateOfHealth($state.params.patientId).then($scope.listeners.onStateOfHealthLoad);
                }, function () {
                    //cancel
                });
            };

            $scope.deleteTakenDrug = function(prescribedDrug) {
                if(prescribedDrug.visit) {
                    if(prescribedDrug.prescription) {
                        $scope.alert('T.MODULE.PATIENT.DRUG_CONNECTED_WITH_VISIT_CARD_AND_PRESCRIPTION');
                    } else {
                        edmApplicationModel.confirm('T.MODULE.PATIENT.DRUG_CONNECTED_WITH_VISIT_CARD').then(function () {
                            $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_CORRECT, { patientId: prescribedDrug.patient.id, visitId: prescribedDrug.visit.id });
                        });
                    }
                } else {
                    var label = prescribedDrug.drug.name;
                    var configPopup = {
                        templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                        controller: 'popupDeleteWithReasonController',
                        controllerAs: 'deleteConfirmCtrl',
                        skipHide: true,
                        locals: {
                            labels: label,
                            item: angular.copy(prescribedDrug),
                            userModel: userModel,
                            $mdDialog: $mdDialog,
                            message: 'T.MODULE.PATIENT.TAKEN_DRUG_DELETE_CONFIRMATION'
                        }
                    };

                    $mdDialog.show(configPopup).then(function(data) {
                        prescribedDrugModel.update(data).then(function() {
                            $scope.getTakenDrugDataPage();
                        })
                    });

                }
            };

            $scope.changeButtonLabel = function() {
                if($scope.showOptions.all) {
                    $scope.buttons[1].label = $translate.instant('T.MODULE.PERSONAL_DATA.SHOW_ACTIVE_ONLY');
                } else {
                    $scope.buttons[1].label = $translate.instant('T.MODULE.PERSONAL_DATA.SHOW_ALL');
                }
            };

            $scope.getTakenDrugDataPage = function(changeButton) {
                if(changeButton) {
                    $scope.showOptions.all = !$scope.showOptions.all;
                    $scope.changeButtonLabel();
                }
                if(!$scope.showOptions.all) {
                    if($scope.criteria.allowDeleted) {
                        delete $scope.criteria.allowDeleted;
                    }
                } else {
                    if(!$scope.criteria.allowDeleted) {
                        $scope.criteria.allowDeleted = true;
                    }
                }
                prescribedDrugModel.getDataPage($scope.criteria).then(listeners.onTakenDrugDataPageLoad);
            };

            $scope.getDataPage = function() {
                $scope.getTakenDrugDataPage(true);
            };

            $scope.userHasAccessToDeleteEntity = function(entity) {
                return entity.author.id === $scope.currentUserId || (entity.author.userType === 'MEDICAL_OFFICE' && userModel.currentUser.userType === Enum.USER_TYPE.DOCTOR);
            };
        }

        function configureInterface() {
        }

        function initialize() {
            applicationModel.fillViewportMode = true;
            $scope.getTakenDrugDataPage();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
